import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-MinusShape",
  "use": "svg-icon-MinusShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"svg-icon-MinusShape\"><defs><path d=\"M1.877 8.875a.875.875 0 1 1 0-1.75h12.247a.875.875 0 1 1 0 1.75H1.877z\" id=\"svg-icon-MinusShape_a\" /></defs><use xlink:href=\"#svg-icon-MinusShape_a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol